import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import useStepper from '../../hooks/useStepper';

export interface Step {
  subtitle?: string;
  content: JSX.Element;
  isCompleted: boolean;
}

interface Props {
  getSteps: (step: number, totalSteps: number) => Step[];
}

const UserStepper: React.FC<Props> = ({ getSteps }) => {
  const { t } = useTranslation();
  const pending = useMemo<number[]>(() => {
    const steps: number[] = [];
    getSteps(0, 0).forEach((step, index) => {
      if (!step.isCompleted) {
        steps.push(index);
      }
    });
    return steps;
  }, []);
  const totalSteps = pending.length;
  const [step, next] = useStepper(totalSteps);

  const index = pending[step];
  const steps = getSteps(step, totalSteps);
  const { subtitle, content, isCompleted } = steps[index];

  useEffect(() => {
    if (isCompleted) {
      next();
    }
  }, [isCompleted]);

  return (
    <StyledWrapper className="flex flex-col h-full pb-6 self-center mobileCtrlUserStepper">
      <h2 className="wizardPageTitle mt-12 mb-4">{t('Let’s get started!')}</h2>
      <p className="text-center text-lg mb-5">
        {subtitle ?? t('Please, ensure all required fields are completed to continue.')}
      </p>
      <div>{content}</div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  width: 71.3rem;

  .wizardPageTitle {
    font-size: 2.8rem;
    font-weight: 700;
    text-align: center;
  }
`;

export default UserStepper;
